import { IsOptional, IsUUID } from "class-validator";
import { PaginatedRequest } from "../../../common/paginated-request/paginated-request.dto";

export class GetAdminAssessmentsRequest extends PaginatedRequest {
    @IsUUID()
    @IsOptional()
    accountId?: string;
}